import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';

import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "search-global-container"
  }, [_c("div", {
    staticClass: "search-top-buttons"
  }, [!_vm.archived ? _c(VBtn, {
    staticClass: "dfwa-btn --small-2",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openScheduleMaintenanceModal();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-plus")]), _vm._v(" New Schedule ")], 1) : _vm._e(), !_vm.archived ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.openLaunchMaintenanceDrawer();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v(_vm._s(_vm.maintenanceMode ? "mdi-update" : "mdi-rocket"))]), _vm._v(" " + _vm._s(_vm.maintenanceMode ? "Update immediate maintenance" : "Launch immediate maintenance") + " ")], 1) : _vm._e(), _vm.maintenanceMode && !_vm.archived ? _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.deactivateMaintenanceMode();
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-stop")]), _vm._v(" Stop maintenance ")], 1) : _vm._e(), _c(VBtn, {
    staticClass: "dfwa-btn secondary --small-2",
    attrs: {
      rounded: true
    },
    on: {
      click: function click($event) {
        return _vm.fetchScheduledMaintenance(0);
      }
    }
  }, [_c(VIcon, {
    attrs: {
      small: "",
      dark: ""
    }
  }, [_vm._v("mdi-refresh")]), _vm._v(" Refresh ")], 1)], 1)]), _c(VDataTable, {
    staticClass: "scheduled-maintenance-table cursor--pointer",
    attrs: {
      loading: _vm.datatable_loading,
      headers: _vm.datatable_headers,
      items: _vm.items,
      "item-key": "id",
      "hide-default-footer": "",
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.start_time",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.formatDate(item.start_time)) + " ")];
      }
    }, {
      key: "item.end_time",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(_vm.formatDate(item.end_time)) + " ")];
      }
    }, {
      key: "item.description",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c("div", {
          staticClass: "description"
        }, [_vm._v(" " + _vm._s(item.description) + " ")])];
      }
    }, {
      key: "item.alert_threshold_minutes",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [item.alert_threshold_minutes ? _c("div", [_c("span", {
          staticClass: "bold"
        }, [_vm._v(_vm._s(item.alert_threshold_minutes))]), _vm._v(" Minutes "), _c("div", [_vm._v("(" + _vm._s(_vm.formatToStringDisplay(item.alert_threshold_minutes)) + ")")])]) : _c("div", [_c("div", [_c("span", {
          staticClass: "bold"
        }, [_vm._v("60")]), _vm._v(" Minutes ")])])];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c("div", {
          staticClass: "actions-container"
        }, [!_vm.archived ? _c(VIcon, {
          attrs: {
            title: "Launch scheduled maintenance",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.LaunchUpcomingMaintenance(item.id);
            }
          }
        }, [_vm._v(" fa fa-rocket ")]) : _vm._e(), _c(VIcon, {
          attrs: {
            title: "Remove scheduled maintenance",
            size: "1rem"
          },
          on: {
            click: function click($event) {
              $event.stopPropagation();
              return _vm.deleteScheduledMaintenance(item.id);
            }
          }
        }, [_vm._v(" fa fa-trash ")])], 1)];
      }
    }], null, true)
  }), _c("ScheduledMaintenanceModal", {
    ref: "ScheduledMaintenanceModalRef",
    on: {
      closed: function closed($event) {
        return _vm.fetchScheduledMaintenance(1000);
      }
    }
  }), _c("LaunchMaintenanceDrawer", {
    ref: "launchMaintenanceDrawer",
    on: {
      closed: function closed($event) {
        return _vm.fetchScheduledMaintenance(1000);
      }
    }
  }), _c("Confirm", {
    ref: "confirm"
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };